import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import * as CS from 'view/pages/createJobPost/commonStyled';

interface ScrollableWrapperProps {
  children: ReactNode;
}

const ScrollableWrapper: FC<ScrollableWrapperProps> = ({ children }) => {
  const scrollableRef = useRef<HTMLDivElement | null>(null);
  const [isScrollable, setIsScrollable] = useState(false);

  const checkScroll = () => {
    if (scrollableRef.current) {
      const { scrollHeight, clientHeight } = scrollableRef.current;
      setIsScrollable(scrollHeight > clientHeight); // ✅ Проверяем, есть ли скролл
    }
  };

  useEffect(() => {
    checkScroll(); // ✅ Запускаем при первом рендере

    // ✅ 1. Отслеживание изменений контента
    const observer = new MutationObserver(() => {
      checkScroll();
    });

    if (scrollableRef.current) {
      observer.observe(scrollableRef.current, { childList: true, subtree: true });
    }

    // ✅ 2. Отслеживание изменения размеров окна и поворотов экрана
    window.addEventListener('resize', checkScroll);
    window.addEventListener('orientationchange', checkScroll);

    return () => {
      observer.disconnect(); // Очистка MutationObserver
      window.removeEventListener('resize', checkScroll);
      window.removeEventListener('orientationchange', checkScroll);
    };
  }, []);

  return (
    <CS.CreateJobPostMainScrollableWrapper ref={scrollableRef} isScrollable={isScrollable}>
      {children}
    </CS.CreateJobPostMainScrollableWrapper>
  );
};

export default ScrollableWrapper;
